import { useState } from "react";
import { UserPlus, UserCog } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { useAuth } from "../lib/auth";
import { useApi, btn } from "./kit";
import { PersonForm } from "../pages/admin/People";

export function TeamMemberDialog({ person, onSaved }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const roles = useApi(open ? "/roles" : null);
  const managers = useApi(open ? "/users/managers" : null);
  const tid = person ? "team-edit-member" : "team-add-member";
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><button className={person ? btn.ghost : btn.dark} data-testid={`${tid}-button`}>
        {person ? <><UserCog className="h-4 w-4" /> Edit details</> : <><UserPlus className="h-4 w-4" /> Add team member</>}</button></DialogTrigger>
      <DialogContent className="max-h-[92vh] overflow-y-auto sm:max-w-2xl" data-testid={`${tid}-dialog`}>
        <DialogHeader><DialogTitle>{person ? `Edit ${person.name}` : "Add a team member"}</DialogTitle></DialogHeader>
        {!person && <p className="text-sm text-muted-foreground">They'll get a welcome email with a sign-in link, and their roles' training is assigned automatically.</p>}
        {roles.data && managers.data && <PersonForm person={person} roles={roles.data} managers={managers.data} limited={!user.is_superadmin}
          defaultManager={user.is_manager ? user.id : ""} onClose={() => setOpen(false)} onSaved={() => { onSaved?.(); }} />}
      </DialogContent>
    </Dialog>
  );
}
